import React from 'react';

const OperatingStandards = () => {
  const standards = [
    {
      icon: '👥',
      title: 'Experienced 24/7 Staff',
      description: 'Our qualified healthcare professionals are available around the clock to provide continuous care and support.'
    },
    {
      icon: '🏠',
      title: 'Absolute Comfort and Home-like Environment',
      description: 'We\'ve created spaces that feel like home, not an institution, with comfortable furnishings and welcoming atmospheres.'
    },
    {
      icon: '🍽️',
      title: 'Home-cooked Meals',
      description: 'Freshly prepared, nutritious meals made with care, tailored to dietary needs and personal preferences.'
    },
    {
      icon: '🎨',
      title: 'Engaging and Interactive Recreation and Activities',
      description: 'Diverse programs designed to promote mental and physical wellness, social connection, and personal fulfillment.'
    }
  ];

  return (
    <section id="operating-standards" className="operating-standards">
      <div className="container">
        <div className="section-header">
          <h2>We Set a High Standard for Each of Our Operating Partners</h2>
          <p>Ensuring consistent quality and exceptional care across all locations</p>
        </div>

        <div className="standards-grid">
          {standards.map((standard, index) => (
            <div key={index} className="standard-card">
              <div className="standard-icon">
                <span>{standard.icon}</span>
              </div>
              <div className="standard-content">
                <h3>{standard.title}</h3>
                <p>{standard.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default OperatingStandards;